import { useEffect, useState } from "react";
import { useOffline } from "./offline-context.js";

/**
 * Compteur « photos à envoyer » de la bannière de sync.
 *
 * Délègue au service, qui borne la lecture aux missions dont les photos
 * peuvent réellement partir. Le compteur lisait auparavant tout le store
 * médias en désérialisant chaque blob, à chaque tick : sur un appareil chargé
 * il expirait en boucle et gardait IndexedDB occupé.
 */
export function usePendingPhotosCount(): number {
  const { tick, service } = useOffline();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!service) return;
    let active = true;
    service
      .pendingUploadCount()
      .then((n) => {
        if (active) setCount(n);
      })
      .catch((err) => {
        // Un compteur d'affichage ne doit jamais remonter en rejet non géré :
        // il bruitait Sentry et la console précisément quand la base souffre.
        console.warn("[offline] compteur photos indisponible", err);
      });
    return () => {
      active = false;
    };
  }, [tick, service]);
  return count;
}
